// src/ProfilePage.jsx
import React, { useState } from "react";
import { User, Save } from "lucide-react";

export default function ProfilePage({ user, onUserUpdate }) {
  const [nome, setNome] = useState(user?.nome || user?.name || [user?.first_name, user?.last_name].filter(Boolean).join(" ") || "");
  const [email] = useState(user?.email || "");
  const [mensagem, setMensagem] = useState("");
  const [tipoMensagem, setTipoMensagem] = useState("info"); // 'info' | 'erro' | 'sucesso'

  function setMsg(msg, tipo = "info") {
    setMensagem(msg);
    setTipoMensagem(tipo);
  }

  function handleSalvar(e) {
    e.preventDefault();
    setMensagem("");

    if (!email) {
      setMsg("Informe um e-mail válido.", "erro");
      return;
    }

    // ainda local – quando tiver endpoint de perfil, a gente liga aqui
    onUserUpdate({ nome, email });

    setMsg("Dados atualizados localmente. (backend em breve)", "info");
  }

  return (
    <div className="profile-page-wrap">
      {/* COLUNA ESQUERDA: PERFIL */}
      <div className="filters-card profile-card animate-fade-in-up" style={{ opacity: 0 }}>
        <h2>Perfil</h2>
        <p className="muted small">
          Atualize seus dados de acesso. Em breve conectamos com a API real para
          dados de perfil.
        </p>

        <form
          onSubmit={handleSalvar}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
            marginTop: "1rem",
          }}
        >
          <label>
            <span style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
              <User size={14} style={{ color: "var(--text-muted)" }} />
              Nome
            </span>
            <input
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              placeholder="Seu nome"
            />
          </label>

          {/*<label>
            <span style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
              <Mail size={14} style={{ color: "var(--text-muted)" }} />
              E-mail
            </span>
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="voce@empresa.com"
            />
          </label>*/}

          <button type="submit" className="submit-btn">
            <Save size={16} />
            Salvar dados
          </button>
        </form>

        {mensagem && (
          <div
            className="export-status-box animate-scale-in"
            style={{
              opacity: 1,
              color:
                tipoMensagem === "erro"
                  ? "#fecaca"
                  : tipoMensagem === "sucesso"
                    ? "#bbf7d0"
                    : "#e5e7eb",
              marginTop: "1rem",
            }}
          >
            {mensagem}
          </div>
        )}
      </div>

      {/* responsivo simples */}
      <style>{`
        .profile-page-wrap{
          display: grid;
          grid-template-columns: minmax(320px, 520px);
          gap: 1.25rem;
          align-items: start;
          width: 100%;
          overflow: visible;
        }

        .profile-page-wrap > .filters-card{
          min-width: 0;
          overflow: visible;
        }
      `}</style>
    </div>
  );
}
